// Cliente das rotas de relatório do alfredo-central-backend.
//
// SOMENTE LEITURA: só há GET aqui, porque relatório não altera dado (§5.1).
// Molde: layoutComanda.service.ts — classe, métodos async, `URLSearchParams`
// para a query, singleton exportado no fim.
import api from "./api.service";
import type {
  EnvelopeDeRelatorio,
  FiltroDeRelatorio,
} from "../comum/relatorios/tipos";

/** Só manda o que tem valor: `?de=&ate=` vira filtro vazio no servidor. */
function montarQuery(filtro: FiltroDeRelatorio): string {
  const parametros = new URLSearchParams();
  Object.entries(filtro).forEach(([chave, valor]) => {
    if (valor !== undefined && valor !== null && String(valor) !== "") {
      parametros.set(chave, String(valor));
    }
  });
  const query = parametros.toString();
  return query ? `?${query}` : "";
}

class RelatorioClass {
  /** Venda, no grão de linha de pedido. Fonte: aod, por SQL cru. */
  async ordens(filtro: FiltroDeRelatorio = {}): Promise<EnvelopeDeRelatorio> {
    const resposta = await api.get(`/reports/ordens${montarQuery(filtro)}`);
    return resposta.data;
  }

  /** Fechamento por turno e por loja. */
  async caixa(filtro: FiltroDeRelatorio = {}): Promise<EnvelopeDeRelatorio> {
    const resposta = await api.get(`/reports/caixa${montarQuery(filtro)}`);
    return resposta.data;
  }

  async estoque(filtro: FiltroDeRelatorio = {}): Promise<EnvelopeDeRelatorio> {
    const resposta = await api.get(`/reports/estoque${montarQuery(filtro)}`);
    return resposta.data;
  }

  async movimentacao(
    filtro: FiltroDeRelatorio = {}
  ): Promise<EnvelopeDeRelatorio> {
    const resposta = await api.get(`/reports/movimentacao${montarQuery(filtro)}`);
    return resposta.data;
  }

  /** Bloqueado na fonte: devolve o diagnóstico medido, não linhas. */
  async clientes(): Promise<EnvelopeDeRelatorio> {
    const resposta = await api.get("/reports/clientes");
    return resposta.data;
  }
}

export const relatorioService = new RelatorioClass();

/** Mensagem de erro no padrão do repo: a do servidor, senão uma em pt-BR. */
export function mensagemDoErro(erro: any): string {
  return (
    erro?.response?.data?.message ??
    "Não foi possível carregar o relatório. Tente novamente."
  );
}
